// @ts-nocheck
/* eslint-disable */
import { store } from "~/state/store";
import { CONFIG } from "~/config";
import MyMapsPopup from "~/es6/mymaps.popup";
import { isFirmFromPoi } from "~/util/review";
import { EMAIL_REGEXP } from "~/report/const";
import { _ } from "~/i18n";
import { frpc } from "~/util/general";
import { createPremiumIcon, icon, node } from "~/util/dom";

window.BadPhoto = class {
	constructor() {
		this._data = null;
		this._cb = null;

		this._popup = new MyMapsPopup({
			name: "badphotopopup",
			cb: data => {
				this._popupEvent(data);
			}
		});
		this._mapOpen = false;
		this._miniMap = null;

		this._reasonsValues = ["position", "badPhoto", "content", "legal", "licence", "other"];

		this._dom = {
			container: this._popup.getContainer(),
			form: {
				container: node("div", { className: "form" }),
				header: node("h2", {}, _("badPhoto.header")),
				reasonsContainer: node("div", { className: "reasons" }),
				reasons: {},
				positionContainer: node("div", { className: "positionContainer" }),
				positionAnchor: node("div", { className: "positionAnchor" }, _("badPhoto.map")),
				map: node("div", { className: "map" }),
				noteLabel: node("label", { className: "note" }),
				noteHeader: node("span", {}, _("badPhoto.note")),
				noteField: node("textarea", { placeholder: _("badPhoto.notePlaceholder") }),
				mailLabel: node("label", { className: "email" }),
				mailHeader: node("span", {}, _("badPhoto.email")),
				mailField: node("input", { type: "text", placeholder: _("badPhoto.emailPlaceholder") }),
				buttonsContainer: node("div", { className: "buttons" }),
				okButton: Mapy.Util.button({ type: "button", className: "send" }, _("submit")),
				cancelButton: Mapy.Util.button({ type: "button", className: "cancel" }, _("cancel")),
				errors: {
					reason: node("div", { className: "error hidden" }),
					note: node("div", { className: "error hidden" }),
					mail: node("div", { className: "error hidden" }),
					global: node("div", { className: "error hidden global" }),
				}
			},
			thanks: {
				container: node("div", { className: "thanks hidden" }),
				header: node("h2", {}, _("badPhoto.thanksHeader")),
				message: node("p", { innerHTML: _("badPhoto.thanksMessage") }),
				buttonsContainer: node("div", { className: "buttons" }),
				button: Mapy.Util.button({ type: "button", className: "cancel" }, _("close")),
			},
			overlay: node("div", { className: "send-overlay" }),
		};

		this._dom.form.okButton.setAttribute("data-log-ignore", "1");
		this._dom.form.cancelButton.setAttribute("data-log-ignore", "1");
		this._dom.form.reasonsContainer.addEventListener("click", this, false);
		this._dom.form.positionAnchor.addEventListener("click", this, false);
		this._dom.form.okButton.addEventListener("click", this, false);
		this._dom.form.cancelButton.addEventListener("click", this, false);
		this._dom.thanks.button.addEventListener("click", this, false);

		this._build();
	}

	set data(data) {
		this._deleteErrors();
		this._data = Object.assign({ url: "", coords: {}, newCoords: null }, data);
	}


	handleEvent(e) {
		if (e.target.closest("div.reasons")) {
			this._dom.form.reasonsContainer.classList.remove("error");
			this._dom.form.errors.reason.textContent = "";
			this._dom.form.errors.reason.classList.add("hidden");
		}

		if (e.target.closest("div.positionAnchor")) {
			e.stopPropagation();
			this._changeMap(!this._mapOpen);
		} else if (e.target.closest("div.reasons label:not(.position)")) {
			this._changeMap();
		}

		switch (e.target) {
			case this._dom.form.okButton: {
				// analytika
				let galleryData = Mapy.getComponent("gallery").isActive() ? Mapy.getComponent("gallery").logData : {};
				let logData = {
					text: "Odeslat problem",
					galleryType: galleryData.galleryType ? galleryData.galleryType : "photomap",
					section: "gallery",
				};

				if (Mapy.getComponent("photoDetail").isActive()) {
					logData.place = "detail";
				}

				Mapy.getComponent("logger").log("click", Object.assign(galleryData, logData));

				this._deleteErrors();

				//kontrola
				let errors = [];
				let reasonRadio = this._dom.form.reasonsContainer.querySelector("label input:checked");
				let note = this._dom.form.noteField.value.trim();
				let mail = this._dom.form.mailField.value.trim();

				if (!reasonRadio) {
					errors.push({ name: "reason" });
				}

				if (reasonRadio && reasonRadio.value == "other" && !note) {
					errors.push({ name: "note" });
				}

				if (!mail) {
					errors.push({ name: "mail" });
				} else {
					let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
					if (!re.test(mail)) {
						errors.push({ name: "mail", text: "notValidEmail" });
					}
				}

				if (!errors.length) {
					document.body.appendChild(this._dom.overlay);
					//odešleme
					this._send(reasonRadio.value, note, mail);
					return;
				}

				errors.forEach(errName => {
					let errEl = this._dom.form.errors[errName.name];
					errEl.textContent = _("badPhoto.errors." + (errName.text || errName.name));
					errEl.classList.remove("hidden");
					switch (errName.name) {
						case "reason": {
							this._dom.form.reasonsContainer.classList.add("error");
							break;
						}
						default: {
							this._dom.form[(errName.name) + "Field"].classList.add("error");
						}
					}
				});
				break;
			}
			case this._dom.form.cancelButton:
			case this._dom.thanks.button: {
				if (e.target == this._dom.form.cancelButton) {
					// analytika
					let galleryData = Mapy.getComponent("gallery").isActive() ? Mapy.getComponent("gallery").logData : {};
					let logData = {
						text: "Zrusit nahlaseni problemu",
						galleryType: galleryData.galleryType ? galleryData.galleryType : "photomap",
						section: "gallery",
					};

					if (Mapy.getComponent("photoDetail").isActive()) {
						logData.place = "detail";
					}

					Mapy.getComponent("logger").log("click", Object.assign(galleryData, logData));
				}

				this._deleteErrors();
				this.close();
				break;
			}
		}
	}

	open(cb) {
		const { user } = store.getState().user;

		this._dom.form.container.classList.remove("hidden");
		this._dom.thanks.container.classList.add("hidden");
		this._deleteErrors();

		if (this._data.coords && "lat" in this._data.coords && "lon" in this._data.coords) {
			if (!this._dom.form.reasonsContainer.contains(this._dom.form.reasons.position.label)) {
				this._dom.form.reasonsContainer.firstChild.before(this._dom.form.reasons.position.label);
			}
			this._changeMap();
			if (this._miniMap) {
				let center = SMap.Coords.fromWGS84(this._data.coords.lon, this._data.coords.lat);
				this._miniMap.setCenter(center, false);
			}
		} else {
			this._dom.form.reasons.position.label.remove();
		}

		this._dom.form.mailField.value = user.state === "green" && user.accountDisplayName.match(EMAIL_REGEXP)? user.accountDisplayName : "";
		this._dom.form.noteField.value = "";
		let checkRadio;
		if (checkRadio = this._dom.form.reasonsContainer.querySelector("label input:checked")) {
			checkRadio.checked = false;
		}
		this._cb = cb;
		this._popup.open();
	}

	close() {
		this._data = null;
		this._popup.close();
		this._cb = null;
	}

	_build() {
		this._reasonsValues.forEach(r => {
			const url = `https://licence.mapy.${CONFIG.TLD}/?doc=mapy_lu`;

			let reason = Mapy.Util.buildRadioCheck("radio", "badPhotoreason", _("badPhoto.reasons." + r, r === 'licence' ? { url } : undefined));
			reason.input.value = r;
			reason.label.classList.add(r);
			this._dom.form.reasons[r] = reason;
			this._dom.form.reasonsContainer.appendChild(reason.label);
		});

		this._dom.form.positionAnchor.appendChild(icon("dropdown"));
		this._dom.form.positionContainer.appendChild(this._dom.form.positionAnchor);
		this._dom.form.reasons.position.title.after(this._dom.form.positionContainer);


		this._dom.form.noteLabel.appendChild(this._dom.form.noteHeader);
		this._dom.form.noteLabel.appendChild(this._dom.form.noteField);
		this._dom.form.mailLabel.appendChild(this._dom.form.mailHeader);
		this._dom.form.mailLabel.appendChild(this._dom.form.mailField);

		this._dom.form.buttonsContainer.appendChild(this._dom.form.okButton);
		this._dom.form.buttonsContainer.appendChild(this._dom.form.cancelButton);

		this._dom.form.container.appendChild(this._dom.form.header);

		// info o premiu
		if (Mapy.CUS.user.premiumReport) {
			const { premium } = store.getState().user.user;

			if (premium) {
				const premiumInfo = node("div", { className: "badphoto-premium-info" });

				premiumInfo.append(createPremiumIcon(), node("p", { innerHTML: _("report.premiumInfo") }));
				this._dom.form.container.appendChild(premiumInfo);
			}
		}

		this._dom.form.container.appendChild(this._dom.form.errors.global);
		this._dom.form.container.appendChild(this._dom.form.reasonsContainer);
		this._dom.form.container.appendChild(this._dom.form.errors.reason);
		this._dom.form.container.appendChild(this._dom.form.noteLabel);
		this._dom.form.container.appendChild(this._dom.form.errors.note);
		this._dom.form.container.appendChild(this._dom.form.mailLabel);
		this._dom.form.container.appendChild(this._dom.form.errors.mail);
		this._dom.form.container.appendChild(this._dom.form.buttonsContainer);

		this._dom.thanks.container.appendChild(this._dom.thanks.header);
		this._dom.thanks.container.appendChild(this._dom.thanks.message);
		this._dom.thanks.buttonsContainer.appendChild(this._dom.thanks.button);
		this._dom.thanks.container.appendChild(this._dom.thanks.buttonsContainer);

		this._dom.container.appendChild(this._dom.form.container);
		this._dom.container.appendChild(this._dom.thanks.container);
	}

	_popupEvent(data) {
		this._cb && this._cb(data);
	}

	_deleteErrors() {
		this._dom.form.reasonsContainer.classList.remove("error");
		this._dom.form.noteField.classList.remove("error");
		this._dom.form.mailField.classList.remove("error");
		Object.keys(this._dom.form.errors).forEach(key => {
			let errEl = this._dom.form.errors[key];
			errEl.textContent = "";
			errEl.classList.add("hidden");
		});
	}

	_send(type, message, reporter_email) {
		const { user } = store.getState().user;
		let outData = {
			source: "mapy",
			reporter_id: user.rusId,
			reporter_email,
			type,
			message,
			url: this._data.url,
			media_id: this._data.id || 0,
		}

		if (type == "position" && this._data.newCoords && (this._data.newCoords.lat != this._data.coords.lat || this._data.newCoords.lon != this._data.coords.lon)) {
			outData.new_mark = this._data.newCoords;
		}

		if (this._data.poi) {
			outData.poi_source = this._data.poi.source;
			outData.poi_id = this._data.poi.id;
		}

		if (this._data.source !== "index") {
			outData.poi_source = this._data.poi ? this._data.poi.source : this._data.source;
			outData.poi_id = this._data.poi ? this._data.poi.id : this._data.id;

			if (!(this._data.source === "ffoto" || isFirmFromPoi(this._data.poi))) {
				delete outData.url;
			}
		}

		if (this._data.source === "index" || (this._data.source === "ffoto" || isFirmFromPoi(this._data.poi))) {
			delete outData.media_id;
		}

		let hints = {
			"0.new_mark.lat": "float",
			"0.new_mark.lon": "float",
		}

		// analytika
		let galleryData = Mapy.getComponent("gallery").isActive() ? Mapy.getComponent("gallery").logData : {};
		let logData = {
			type: Math.max(this._reasonsValues.indexOf(type), 0) + 1,
			text: message.length ? 1 : 0,
			galleryType: galleryData.galleryType ? galleryData.galleryType : "photomap",
			section: "gallery",
		};

		if (Mapy.getComponent("photoDetail").isActive()) {
			logData.place = "detail";
		}

		Mapy.getComponent("logger").log("problem-leti", Object.assign(galleryData, logData));

		frpc({
			url: CONFIG.requestUrl + "/mediarpc",
			method: "issue.add",
			args: [outData],
			hints,
		}).promise.then(() => {
			this._dom.form.container.classList.add("hidden");
			this._dom.thanks.container.classList.remove("hidden");
			this._dom.overlay.remove();
		}).catch(err => {
			if ("status" in err && err.status == 442) {
				this._dom.form.errors.mail.classList.remove("hidden");
				this._dom.form.errors.mail.textContent = _("badPhoto.errors.notValidEmail");
				this._dom.form.mailField.classList.add("error");
			} else {
				this._dom.form.errors.global.textContent = _("badPhoto.errors.global");
				this._dom.form.errors.global.classList.remove("hidden");
			}
			this._dom.overlay.remove();
		});

	}

	_changeMap(open = false) {
		this._mapOpen = open;
		this._dom.form.positionContainer.classList[open ? "add" : "remove"]("open");
		if (open) {
			this._dom.form.positionContainer.appendChild(this._dom.form.map);
			if (!this._dom.form.map.children.length) {
				this._createMinimap();
			}
		} else {
			this._dom.form.map.remove();
		}
	}

	_createMinimap() {
		let center = SMap.Coords.fromWGS84(this._data.coords.lon, this._data.coords.lat);
		this._miniMap = new SMap(this._dom.form.map, center, 17);
		this._miniMap.addDefaultLayer(SMap.DEF_TURIST).enable();
		this._miniMap.addControl(new SMap.Control.Mouse(SMap.MOUSE_PAN | SMap.MOUSE_ZOOM | SMap.MOUSE_WHEEL));

		let xCont = node("div", { className: "crossMinimap" });
		xCont.innerHTML = `<svg x="0px" y="0px" viewBox="0 0 26 26"><polygon class="stroke" points="11,0 11,11 0,11 0,15 11,15 11,26 15,26 15,15 26,15 26,11 15,11 15,0 "/><polygon class="crossHair" points="14,25 12,25 12,14 1,14 1,12 12,12 12,1 14,1 14,12 25,12 25,14 14,14 "/></svg>
`;
		this._dom.form.map.appendChild(xCont);

		let signals = this._miniMap.getSignals();
		signals.addListener(this._dom.form.map, "map-redraw", () => {
			let center = this._miniMap.getCenter().toWGS84();
			if (!this._data.newCoords) {
				this._data.newCoords = { lat: this._data.coords.lat, lon: this._data.coords.lon };
			}
			this._data.newCoords.lat = center[1];
			this._data.newCoords.lon = center[0];
		});
	}
}
